module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/9-02fc17f44a39167da96302d25ed87cae.jpg";